var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGyen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.837 11.69h-6.15c-.384-.846-3.074-2.384-7.072-2.384-7.072 0-8.917 4.997-8.917 6.611 0 1.614 1.076 6.457 8.917 6.457 6.273 0 8.712-3.228 9.148-4.843h-9.148c-.307-.024-.922-.29-.922-1.152 0-.86.615-1.28.922-1.383H30.99c.05.768-.062 2.752-.923 4.535-1.076 2.23-6.765 5.612-14.452 5.612S3.777 21.913 2.01 19.53c-1.77-2.383-.847-5.842 0-6.918C2.854 11.535 5.775 7 15.614 7c7.872 0 12.095 3.126 13.222 4.69z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGyen);
export default __webpack_public_path__ + "static/media/GYEN.320fd558ba0daf58ec31b909b9d8de9d.svg";
export { ForwardRef as ReactComponent };